import React from 'react';

export function useIntersectionObserver(
  disableObserver: boolean,
  intersectionOptions: Record<string, string | number> = {}
) {
  const [intersected, setIntersected] = React.useState<boolean>(false);
  const ref = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    if (!('IntersectionObserver' in window) || disableObserver) {
      setIntersected(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIntersected(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.01, ...intersectionOptions }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (observer && observer.disconnect) observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current, disableObserver]);

  return { ref, intersected };
}
